module.exports = __webpack_public_path__ + "static/media/ic_location_on.0293957d.png";